/**-----------------------------------------------------------------------------------------
* Copyright © 2023 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the package root for more information
*-------------------------------------------------------------------------------------------*/
"use client";
import * as e from "react";
import r from "prop-types";
import { validatePackage as H, useRtl as W, classNames as L, getTabIndex as q } from "@progress/kendo-react-common";
import { useAnimation as Q } from "@progress/kendo-react-animation";
const X = 1e-5, Y = 3, Z = 400, ee = 0, se = (s) => {
  const t = s.toString().split(".");
  return t.length === 1 ? `${t[0]}` : `${t[0]}.${t[1].substr(0, Y)}`;
}, K = (s, t, a) => {
  const n = Math.abs((t - s) / 100);
  return Math.abs((a - s) / n);
}, _ = (s, t, a, n) => {
  const u = Math.max(a, 0.01), h = 100 / u * 100;
  s.current && t.current && (s.current.style.width = n ? "100%" : `${u}%`, t.current.style.width = n ? "100%" : `${h}%`, s.current.style.height = n ? `${u}%` : "100%", t.current.style.height = n ? `${h}%` : "100%");
}, re = (s, t, a) => Math.max((a - s) / (t - s), X), G = {
  name: "@progress/kendo-react-progressbars",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1702644661,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/components/my-license/"
}, j = e.forwardRef((s, t) => {
  H(G);
  const {
    chunkCount: a = y.chunkCount,
    className: n,
    disabled: u,
    orientation: h,
    min: S = y.min,
    max: g = y.max,
    reverse: i = y.reverse,
    style: m,
    tabIndex: M,
    emptyStyle: T,
    emptyClassName: O,
    progressStyle: D,
    progressClassName: I
  } = s, k = e.useRef(null), R = e.useCallback(
    () => {
      k.current && k.current.focus();
    },
    []
  );
  e.useImperativeHandle(t, () => ({
    element: k.current,
    focus: R
  }));
  const d = s.value || y.value, b = s.value === null, v = W(k, s.dir), N = h === "vertical", o = {
    className: L(
      "k-progressbar k-chunk-progressbar",
      {
        "k-progressbar-horizontal": !N,
        "k-progressbar-vertical": N,
        "k-progressbar-reverse": i,
        "k-progressbar-indeterminate": b,
        "k-disabled": u
      },
      n
    ),
    ref: k,
    dir: v,
    tabIndex: q(M, u),
    role: "progressbar",
    "aria-label": s.ariaLabel,
    "aria-valuemin": S,
    "aria-valuemax": g,
    "aria-valuenow": b ? void 0 : d,
    "aria-disabled": u,
    style: m
  }, f = ({ count: p }) => {
    let w = [];
    const c = 100 / p + "%", $ = re(S, g, d), U = Math.floor($ * p), E = Array(p).fill(!1);
    for (let l = 0; l < U; l++)
      E[l] = !0;
    for (let l = 0; l < p; ++l) {
      const C = E[l], A = C ? I : O, B = { ...{
        width: N ? void 0 : c,
        height: N ? c : void 0
      }, ...C ? D : T };
      w.push(
        /* @__PURE__ */ e.createElement(
          "li",
          {
            key: l,
            className: L(
              "k-progress-chunk",
              {
                "k-first": l === 0,
                "k-last": l === p - 1,
                "k-selected": C
              },
              A
            ),
            style: B
          }
        )
      );
    }
    return /* @__PURE__ */ e.createElement(e.Fragment, null, w);
  };
  return /* @__PURE__ */ e.createElement("div", { ...o }, /* @__PURE__ */ e.createElement("ul", { className: "k-progressbar-chunks k-reset" }, /* @__PURE__ */ e.createElement(f, { count: a || y.chunkCount })));
});
j.propTypes = {
  chunkCount: r.number,
  ariaLabel: r.string,
  disabled: r.bool,
  reverse: r.bool,
  max: r.number,
  min: r.number,
  value: r.number,
  tabIndex: r.number,
  emptyStyle: r.object,
  emptyClassName: r.string,
  progressStyle: r.object,
  progressClassName: r.string
};
const y = {
  chunkCount: 5,
  min: 0,
  max: 100,
  value: 0,
  disabled: !1,
  reverse: !1
};
j.defaultProps = y;
j.displayName = "KendoChunkProgressBar";
const te = (s) => {
  const t = e.useRef();
  return e.useEffect(() => {
    t.current = s;
  }), t.current;
}, z = e.forwardRef((s, t) => {
  H(G);
  const {
    animation: a,
    disabled: n,
    reverse: u = x.reverse,
    orientation: h,
    labelVisible: S,
    labelPlacement: g,
    max: i = x.max,
    min: m = x.min,
    tabIndex: M,
    className: T,
    style: O,
    emptyStyle: D,
    emptyClassName: I,
    progressStyle: k,
    progressClassName: R
  } = s, d = e.useRef(null), b = e.useRef(null), v = e.useRef(null), N = e.useCallback(
    () => {
      d.current && d.current.focus();
    },
    []
  );
  e.useImperativeHandle(
    t,
    () => ({
      element: d.current,
      progressStatusElement: b.current,
      progressStatusWrapElement: v.current,
      focus: N
    })
  );
  const o = s.value || x.value, f = te(o), p = s.value === null, w = W(d, s.dir), c = h === "vertical", $ = se(o), U = {
    value: o
  }, E = S ? s.label ? /* @__PURE__ */ e.createElement("span", { className: "k-progress-status" }, /* @__PURE__ */ e.createElement(s.label, { ...U })) : /* @__PURE__ */ e.createElement("span", { className: "k-progress-status" }, $) : void 0, l = {
    className: L(
      "k-progressbar",
      {
        "k-progressbar-horizontal": !c,
        "k-progressbar-vertical": c,
        "k-progressbar-reverse": u,
        "k-progressbar-indeterminate": p,
        "k-disabled": n
      },
      T
    ),
    ref: d,
    dir: w,
    tabIndex: q(M, n),
    role: "progressbar",
    "aria-label": s.ariaLabel,
    "aria-valuemin": m,
    "aria-valuemax": i,
    "aria-valuenow": p ? void 0 : o,
    "aria-disabled": n,
    style: O
  }, C = L("k-progress-status-wrap", {
    "k-progress-start": g === "start",
    "k-progress-center": g === "center",
    "k-progress-end": g === "end" || g === void 0
  }), A = typeof a != "boolean" && a !== void 0 ? a.duration : a ? Z : ee, V = e.useCallback(
    () => {
      const P = K(m, i, f);
      _(b, v, P, c);
    },
    [c, i, m, f]
  ), F = e.useCallback(
    (P) => {
      const J = K(m, i, f + (o - f) * P);
      _(b, v, J, c);
    },
    [m, i, f, o, c]
  ), B = e.useCallback(
    () => {
      const P = K(m, i, o);
      _(b, v, P, c);
    },
    [c, i, m, o]
  );
  return Q(
    {
      duration: A,
      onStart: V,
      onUpdate: F,
      onEnd: B
    },
    [o, A]
  ), /* @__PURE__ */ e.createElement("div", { ...l }, /* @__PURE__ */ e.createElement("span", { className: C + (I ? " " + I : ""), style: D }, E), /* @__PURE__ */ e.createElement(
    "div",
    {
      className: "k-progressbar-value k-selected",
      style: k,
      ref: b
    },
    /* @__PURE__ */ e.createElement(
      "span",
      {
        className: C + (R ? " " + R : ""),
        ref: v
      },
      E
    )
  ));
});
z.propTypes = {
  animation: r.any,
  ariaLabel: r.string,
  disabled: r.bool,
  reverse: r.bool,
  label: r.any,
  labelVisible: r.bool,
  labelPlacement: r.oneOf(["start", "center", "end"]),
  max: r.number,
  min: r.number,
  value: r.number,
  tabIndex: r.number,
  emptyStyle: r.object,
  emptyClassName: r.string,
  progressStyle: r.object,
  progressClassName: r.string
};
const x = {
  animation: !1,
  min: 0,
  max: 100,
  value: 0,
  disabled: !1,
  reverse: !1,
  labelVisible: !0
};
z.defaultProps = x;
z.displayName = "KendoProgressBar";
export {
  j as ChunkProgressBar,
  z as ProgressBar
};
